import { validate } from 'jquery-validation';
import * as validation_it from 'jquery-validation/dist/localization/messages_lt';
import * as validation_unobtrusive from 'jquery-validation-unobtrusive';

// - enforcetrue validator
$.validator.addMethod("enforcetrue", function (value, element, param) { return element.checked; });
$.validator.unobtrusive.adapters.addBool("enforcetrue");